export default __webpack_public_path__ + "static/media/Prosecutor Office.ee65352d.jpg";